<template>
   <div class="login" id="bloque1" >

      <div class="loginBox">
        <img class="loginBoxImg" src="/dist/logo-login.png" >
        <p class="labels" id="titulo" style="font-weight: 400; font-size: 23px; margin-bottom: 20px">Sales Login</p>

        <form @submit.prevent>
          <p class="labels">USUARIO</p>
          <input class="inputBox" :class="{inputBoxError: errorUser}" type="email" v-model='usuario' >
          <p class="labels" style="margin-top: 10px">CONTRASEÑA</p>
          <input class="inputBox" :class="{inputBoxError: errorPass}" type="password" v-model='pass' >
          <p id="forgetPass" @click='btnOlvidePass'>Olvide mi contraseña</p> 
          <div id="btnContainer">
            <button id="btnIngresar" @click="btnLogin"   >INGRESAR</button>
            <button id="btnRegistro" @click='btnRegistro'>REGISTRARME</button>
          </div>
        </form>

      </div>
  </div>
</template>


<script>
import axios from "axios";

export default {
  name: "Login",

  data() {
    return {
      usuario: "",
      pass: "",
      errorUser: false,
      errorPass: false
    };
  },

  methods: {
    btnLogin() {
      this.errorUser = false;
      this.errorPass = false;
      if (this.usuario.length < 6) {
        this.errorUser = true;
      }
      if (this.pass.length < 4) {
        this.errorPass = true;
      }

      if (!this.errorUser && !this.errorPass) {
        this.login();
      }
    },

    login()
    {
      this.$store.commit("loader/start");
      var header = { "Content-Type": "application/json" };

      var data = 
      {
        Usuario: this.usuario.trim(),
        Password: this.pass.trim(),
        ClientSecret: process.env.CLIENT_SECRET
      };

      axios.post("/WebSalesLogin", data, header).then(
        response => {
          this.$store.commit("loader/stop");
          if (response.data.Code == 0) 
          {
            console.log('login', response.data)
            localStorage.setItem("lastActivity",Math.floor(Date.now() / 1000));
            this.$store.commit("user/saveUsuario", response.data);
            this.$access(response.data.EsEmpleado ? ['seller', 'user'] : 'user');

            // solicita datos solo cuando no es un empleado
            if (!response.data.EsEmpleado) 
            {
              this.getDatosCliente();
            }
            else 
            {
              this.$router.push({ name: "clientes" })
            }

          } 
          else 
          {
            var obj = 
            {
              txt: response.data.Message,
              txtBtnCancel: "",
              txtBtnOk: "Aceptar",
              fCancel: null,
              fOk: null
            };
            this.$store.commit("popup/open", obj);
          }
        },
        error => {
          this.$store.commit("loader/stop");
          console.log(error);
          alert(error + "1");
        }
      );
    },

    getDatosCliente() {
      axios
        .get("/WebSalesCliente?ClienteId=" + this.$store.state.user.usuario.ClienteId, {
          headers: {
            Token: this.$store.state.user.usuario.Token,
            ClientSecret: process.env.CLIENT_SECRET
          }
        })
        .then(
          response => {
            if (response.data.Code == 0) 
            {
              this.$store.commit("user/saveCliente", response.data);
              this.$router.push({ name: "home" });
              this.$store.commit('pedido/saveMoneda',response.data.ListaPrecioMoneda)
            } 
            else if (response.data.Code == 99) 
            {
              this.$store.commit("loader/stop");
              alert(response.data.Message);
              this.$router.push({ name: "login" });
            }
            else
            {
              this.$store.commit("loader/stop");
              alert(response.data.Message);
              console.log(">>code>>" + response.data.Code);
            }
          },
          error => {
            this.$store.commit("loader/stop");
            console.log(error);
            alert(error + "2");
          }
        );
    },

    btnRegistro() {
      this.$router.push({ name: "registro" });
    },

    btnOlvidePass() {
      if (this.usuario.length > 5) {
        var obj = {
          txt:
            "Se le enviara una nueva contraseña al email indicado en el campo usuario",
          txtBtnCancel: "Cancelar",
          txtBtnOk: "Aceptar",
          fCancel: null,
          fOk: this.enviarPass
        };
        this.$store.commit("popup/open", obj);
      } else {
        var obj = {
          txt:
            "Debe ingresar su usuario para poder enviarle su nueva contraseña",
          txtBtnCancel: "",
          txtBtnOk: "Aceptar",
          fCancel: null,
          fOk: null
        };
        this.$store.commit("popup/open", obj);
      }
    },

    enviarPass() {
      this.$store.commit("loader/start");
      var bdParam = {
        Usuario: this.usuario,
        ClientSecret: process.env.CLIENT_SECRET,
        EmpresaId: process.env.EMPRESA_ID
      };
      axios.put("/WebSalesContrasenia", bdParam).then(
        response => {
          this.$store.commit("loader/stop");
          if (response.data.Code == 0) {
            var obj = {
              txt: "La nueva contraseña ha sido enviada a su email",
              txtBtnCancel: "",
              txtBtnOk: "Aceptar",
              fCancel: null,
              fOk: null
            };
            this.$store.commit("popup/open", obj);
          } else if (response.data.Code == 99) {
            alert(response.data.Message);
          } else {
            alert(">>>>" + response.data.Message);
            console.log(">>>>" + response.data.Message);
          }
        },
        error => {
          console.log(error);
          alert(error);
        }
      );
    }
  },

  mounted() 
  {
    this.$store.commit("loader/stop");
    if (this.$store.state.user.usuario != null)
    {
      var lastActivity  = Number(localStorage.getItem('lastActivity') || 0) 
      var currentMillis = Number(Math.floor(Date.now() / 1000))
      var sesionTime    = lastActivity + Number(process.env.EXPIRATION_SESION)
      if (sesionTime >= currentMillis)
      {
        if (this.$store.state.user.usuario.esEmpleado) 
        {
          this.$access("seller");
          this.$router.push({ name: "clientes" })
        }
        else 
        {
          this.$access("user");
          this.$router.push({ name: 'home' });
        }
      }
      else
      {
        this.$access("any");
        this.$store.commit("user/delete");
        this.$store.commit("pedido/delete");
      }
    }
  }

};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

#bloque1 {
  width: 100%;
  height: 100vh;
  background: linear-gradient(#005a9f, #1899d6);
}

.loginBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  height: 350px;
  padding: 20px;
  border-radius: 15px;
  box-sizing: border-box;
  background: #ffffff;
}

.loginBoxImg {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  top: calc(-100px / 2);
  left: calc(50% - 50px);
}

.labels {
  margin: 0;
  padding-bottom: 5px;
  font-weight: 500;
  font-size: 10px;
  color: #5c666f;
}

#titulo {
  margin-top: 50px;
  padding: 0, 0, 20px;
  text-align: center;
  font-size: 20px;
}

.inputBox {
  width: 305px;
  margin-bottom: 20px;
  padding-left: 5px;
  border-radius: 5px;
  margin-bottom: 10px;
  height: 30px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #dddddd;
}

.inputBoxError {
  width: 305px;
  margin-bottom: 20px;
  padding-left: 5px;
  border-radius: 5px;
  margin-bottom: 10px;
  height: 30px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #ff0000;
}

#forgetPass {
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  color: #4969b2;
}

#btnContainer {
  margin-top: 30px;
  text-align: center;
}

input[type="submit"] {
  height: 30px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 20px;
  border-style: solid;
  border: none;
}

#btnRegistro {
  width: 100%;
  margin-bottom: 20px;
  margin-right: 5px;
  height: 30px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 20px;
  border-style: solid;
  border: none;
  text-align: center;
  width: 100px;
  height: 30px;
  color: #5c666f;
  background: #ffffff;
  border-width: 1px;
  border: 2px solid #5c666f;
  outline: none;
}

#btnIngresar {
  width: 100%;
  margin-bottom: 20px;
  margin-left: 5px;
  height: 30px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 20px;
  border-style: solid;
  border: none;
  text-align: center;
  width: 80px;
  background: #005a9f;
  color: #ffffff;
  border-width: 1px;
  border: 2px solid #005a9f;
  outline: none;
}

#btnRegistro:hover {
  cursor: pointer;
}
#btnIngresar:hover {
  cursor: pointer;
}
#forgetPass:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/views/login/login.vue